module.exports = __webpack_public_path__ + "static/media/home-placeholder.b79e054c.webp";